import React from "react";
import SimplePage from "../../components/legal/SimplePage";
import { useCurrency } from "../../context/CurrencyContext";

export default function HelpCenter() {
  const { settings } = useCurrency();
  return <SimplePage eyebrow="Support" title="Help Center" text={settings?.content_help} loading={!settings?.content_help} />;
}
